import { render, staticRenderFns } from "./FormalStudentList.vue?vue&type=template&id=6438590c&scoped=true&"
import script from "./FormalStudentList.vue?vue&type=script&lang=js&"
export * from "./FormalStudentList.vue?vue&type=script&lang=js&"
import style0 from "./FormalStudentList.vue?vue&type=style&index=0&id=6438590c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6438590c",
  null
  
)

export default component.exports